import React from 'react';
import { Link } from 'react-router-dom';
import { GlobeIcon, MailIcon, MessageCircleIcon } from 'lucide-react';
import { Logo } from './Logo';
import { brand, contact, links, nav, whatsappUrl } from '../data/site';
const footerServices = ['Brand Identity', 'Logo Design', 'Motion Graphics', 'Packaging', 'Social Media', 'Presentation Design'];
const youtubeUrl = 'https://www.youtube.com/@morvixdesign';

/** Opens the visitor's default mail client with a pre-filled template enquiry. */
const templatesMailto = `mailto:morvixagencyofficial@gmail.com?subject=${encodeURIComponent('Purchase Design Templates')}&body=${encodeURIComponent('Hello,\n\nI would like to purchase your design templates.\nPlease share the available template collections and pricing.\n\nThank you.')}`;
const socials = [{
  label: 'Facebook',
  href: links.facebook
}, {
  label: 'Instagram',
  href: links.instagram
}, {
  label: 'TikTok',
  href: links.tiktok
}, {
  label: 'Pinterest',
  href: links.pinterest
}, {
  label: 'Linktree',
  href: links.linktree
}];
export function Footer() {
  return <footer className="border-t border-line bg-surface" aria-label="Site footer" data-id="element-225" data-mp="3gaz4da2vgxn9">
      <div className="mx-auto w-full max-w-container px-5 py-16 sm:px-8 sm:py-20" data-id="element-226" data-mp="3v7q79tbr8rhm">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]" data-id="element-227" data-mp="3v5deel4gkwps">
          <div data-id="element-228" data-mp="3q726ifxq4wa7">
            <Logo data-id="element-229" data-mp="3qapz9cvchenv" />
            <p className="mt-5 max-w-xs font-serif text-2xl italic leading-snug" data-id="element-230" data-mp="830ibgbgg0zf">
              {brand.tagline}
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-muted" data-id="element-231" data-mp="34pafb4q00ju">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-232" data-mp="hsk3wtqjy8xz" />
              {brand.serviceModel}
            </p>
          </div>

          <nav aria-label="Footer navigation" data-id="element-233" data-mp="cus1v6w716g2">
            <h2 className="label text-muted" data-id="element-234" data-mp="cw34329zq652">Navigate</h2>
            <ul className="mt-5 space-y-2.5" data-id="element-235" data-mp="qub79rxme3oo">
              {nav.map(item => <li key={item.to} data-id="element-236" data-mp="msppbs68az7m">
                  <Link to={item.to} className="text-sm text-ink transition-colors hover:text-brand" data-id="element-237" data-mp="mtra4od1r02j">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-238" data-mp="13rpsgnl9gf8u">
            <h2 className="label text-muted" data-id="element-239" data-mp="13r7mgz8sqmnq">Services</h2>
            <ul className="mt-5 space-y-2.5" data-id="element-240" data-mp="18k98dr7f7mgt">
              {footerServices.map(service => <li key={service} data-id="element-241" data-mp="1cmdzai6hi4zr">
                  <Link to="/services" className="text-sm text-ink transition-colors hover:text-brand" data-id="element-242" data-mp="1clcli5y334ec">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-243" data-mp="1rid2beeqley1">
            <h2 className="label text-muted" data-id="element-244" data-mp="1rgsj2kxvhifh">Contact</h2>
            <ul className="mt-5 space-y-3" data-id="element-245" data-mp="3obwx4zca68oj">
              <li data-id="element-246" data-mp="3od857bcre2lg">
                <a href={`mailto:${contact.email}`} className="flex items-center gap-2 text-sm text-ink transition-colors hover:text-brand" data-id="element-247" data-mp="3ta8b9m9lz5ck">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-248" data-mp="25of1aavcg6kh" />
                  {contact.email}
                </a>
              </li>
              <li data-id="element-249" data-mp="21nv5bamib8zx">
                <a href={whatsappUrl} target="_blank" rel="noreferrer noopener" className="flex items-center gap-2 text-sm text-ink transition-colors hover:text-brand" data-id="element-250" data-mp="21nbk9l1k84ho">
                  <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-251" data-mp="2pbuuw7830tcx" />
                  {contact.whatsappDisplay}
                </a>
              </li>
              <li className="text-sm text-muted" data-id="element-252" data-mp="2kfe6rd0vuezu">{brand.hours}</li>
            </ul>

            <h2 className="label mt-8 text-muted" data-id="element-253" data-mp="2fdow3yhko3ca">Social</h2>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-2" data-id="element-254" data-mp="18yefmkq9u67e">
              {socials.map(social => <li key={social.label} data-id="element-255" data-mp="13y05mx540m6q">
                  <a href={social.href} target="_blank" rel="noreferrer noopener" className="text-sm text-ink underline decoration-line underline-offset-4 transition-colors hover:text-brand hover:decoration-brand" data-id="element-256" data-mp="1414guegzsi6w">
                    {social.label}
                  </a>
                </li>)}
              <li data-id="element-257" data-mp="2nrrud6d7w7qq">
                <a href={templatesMailto} className="text-sm text-ink underline decoration-line underline-offset-4 transition-colors hover:text-brand hover:decoration-brand" data-id="element-258" data-mp="3bjzyrmt0cqds">
                  Buy Design Templates
                </a>
              </li>
            </ul>

            <p className="mt-6 max-w-xs text-xs leading-relaxed text-muted" data-id="element-259" data-mp="36judqph8u24o">
              Want to learn Graphic Design for free? Visit our YouTube channel.
            </p>
            <a href={youtubeUrl} target="_blank" rel="noreferrer noopener" className="mt-1.5 inline-block text-xs text-muted underline decoration-line underline-offset-4 transition-colors hover:text-brand hover:decoration-brand" data-id="element-260" data-mp="1v5gs7r9ypyrt">
              www.youtube.com/@morvixdesign
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-line pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-261" data-mp="1wk9t7472y52p">
          <p className="label text-muted" data-id="element-262" data-mp="13xgqwhe1kxql">© 2026 {brand.name}. All rights reserved.</p>
          <p className="label text-muted" data-id="element-263" data-mp="zwn0nhd4n6uj">
            A {brand.parent} studio · Founded by {brand.founder}
          </p>
        </div>
      </div>
    </footer>;
}